import React, { useEffect } from "react";
import s from "~/views/not-found/NotFoundPage.module.scss";
import ROUTES from "~/utils/routes";
import { Link } from "react-router-dom";
import сonfig from "~/config";
import { logEvent } from "~/utils/amplitude";

interface Props {}

const NotFoundPage: React.FC<Props> = ({}) => {
  useEffect(() => {
    logEvent("Э/ Страница 404");
  }, []);

  return (
    <div className="screen-container">
      <div className={s.notfound}>
        <img
          className={s.notfoundImage}
          src="https://onlinezdrav.ru/assets/404.svg"
        />

        <h1 className={s.notfoundTitle}>Страница удалена или ее не было</h1>

        <p className={s.notfoundDescription}>
          Откройте <a href={сonfig.seoPartUrl}>список больниц</a> доступных для{" "}
          <Link to={ROUTES.LOGIN.PATHNAME}>онлайн записи</Link> или вернитесь на
          <a href={сonfig.seoPartUrl} target="_blank" rel="noopener noreferrer">
            главную страницу
          </a>
        </p>
      </div>
    </div>
  );
};

export default NotFoundPage;
